import { render, staticRenderFns } from "./DocumentComponent.vue?vue&type=template&id=2f8048c0&scoped=true&"
import script from "./DocumentComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentComponent.vue?vue&type=style&index=0&id=2f8048c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8048c0",
  null
  
)

export default component.exports